/**
 * Quem enxerga a Estruturação de squads.
 *
 * A tela compara os squads entre si (capacidade, entrega, custo) e serve à
 * gestão, não a quem toca um projeto só. O admin enxerga, como no resto do
 * sistema.
 *
 * A lista é de exclusão de propósito: squad novo continua enxergando por
 * padrão, que era o comportamento antes deste corte — para tirar alguém,
 * acrescente o nome aqui. O dado da Estruturação vive no navegador
 * (ver `squad-metrics`), então não há espelho no backend.
 */
export const SQUADS_SEM_ESTRUTURACAO = ['India', 'Demo'];

export function podeAcessarEstruturacao(squadNome: string | null | undefined, isAdmin: boolean): boolean {
  if (isAdmin) return true;
  if (!squadNome) return true;
  return !SQUADS_SEM_ESTRUTURACAO.some((s) => s.toLowerCase() === squadNome.toLowerCase());
}
